import { render, staticRenderFns } from "./CreateOrderShipping.vue?vue&type=template&id=0a87f67c&scoped=true&"
import script from "./CreateOrderShipping.vue?vue&type=script&lang=js&"
export * from "./CreateOrderShipping.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderShipping.vue?vue&type=style&index=0&id=0a87f67c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a87f67c",
  null
  
)

export default component.exports